export function ConvertLogsPaymentProvider(provider) {
    let firstPart = provider.split('_')[0];

    if ('PAYME'.includes(firstPart)) {
        return 'PayMe';
    } else if ('CLICK'.includes(firstPart)) {
        return 'Click';
    } else if ('UZUM'.includes(firstPart) || 'ALEPSIN'.includes(firstPart)) {
        return 'Uzum';
    } else if ('ANOR'.includes(firstPart)) {
        return 'Anor';
    } else {
        return null;
    }
}


export function ConvertCardType(type, translate = true, t = null) {
    const cardTypes = {
        0: 'unknown',
        1: 'personal',
        2: 'corporate',
        3: 'social'
    }
    const convertedType = cardTypes[type];

    if (translate && t) {
        return t(`common.cardTypes.${convertedType}`)
    }

    return convertedType;
}